import getStore from '../data/store/store';
import { getIsAutomaticReplyEnabled, getPeriodicReplyEnabled, getBlockCalendarEnabled, getDeclineNewInvitationsEnabled, getSendRepliesToContactsOnlyEnabled, getSendRepliesOutsideOrgEnabled, getBlockCalendarTitle, getStartDate, getEndDate, getDeclineExistingCalendarEventsEnabled, } from '../selectors/getStoreProperties';
/**
 * Utility function to check if automatic replies option is dirty
 * @returns true if dirty else false
 */
export default function isAutomaticRepliesOptionDirty() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    var intialIsAutomaticReplyEnabled = initialState.isAutomaticReplyEnabled;
    var initialPeriodicReplyEnabled = initialState.periodicReplyEnabled;
    var initialBlockCalendarEnabled = initialState.blockCalendarEnabled;
    var initialBlockCalendarTitle = initialState.blockCalendarTitle;
    var initialDeclineNewInvitationsEnabled = initialState.declineNewInvitationsEnabled;
    var initialDeclineExistingInvitationsEnabled = false;
    var initialSendRepliesToContactsOnlyEnabled = initialState.sendRepliesToContactsOnlyEnabled;
    var initialSendRepliesOutsideOrgEnabled = initialState.sendRepliesOutsideOrgEnabled;
    var initialStartDate = initialState.startDate;
    var initialStartDateStr = initialStartDate ? initialStartDate.toString() : null;
    var initialEndDate = initialState.endDate;
    var initialEndDateStr = initialEndDate ? initialEndDate.toString() : null;
    var currentIsAutomaticReplyEnabled = getIsAutomaticReplyEnabled();
    var currentPeriodicReplyEnabled = getPeriodicReplyEnabled();
    var currentBlockCalendarEnabled = getBlockCalendarEnabled();
    var currentBlockCalendarTitle = getBlockCalendarTitle();
    var currentDeclineNewInvitationsEnabled = getDeclineNewInvitationsEnabled();
    var currentDeclineExistingInvitationsEnabled = getDeclineExistingCalendarEventsEnabled();
    var currentSendRepliesOnlyToContactsEnabled = getSendRepliesToContactsOnlyEnabled();
    var currentSendRepliesOutsideOrgEnabled = getSendRepliesOutsideOrgEnabled();
    var currentStartDate = getStartDate();
    var currentStartDateStr = currentStartDate ? currentStartDate.toString() : null;
    var currentEndDate = getEndDate();
    var currentEndDateStr = currentEndDate ? currentEndDate.toString() : null;
    var isDirty = optionsState.editorViewStateMessage.isDirty ||
        optionsState.editorViewStateDeclineMeeting.isDirty ||
        optionsState.editorViewStateOutsideOrg.isDirty ||
        currentPeriodicReplyEnabled !== initialPeriodicReplyEnabled ||
        currentIsAutomaticReplyEnabled !== intialIsAutomaticReplyEnabled ||
        currentBlockCalendarEnabled !== initialBlockCalendarEnabled ||
        currentDeclineNewInvitationsEnabled !== initialDeclineNewInvitationsEnabled ||
        currentSendRepliesOnlyToContactsEnabled !== initialSendRepliesToContactsOnlyEnabled ||
        currentSendRepliesOutsideOrgEnabled !== initialSendRepliesOutsideOrgEnabled ||
        currentDeclineExistingInvitationsEnabled !== initialDeclineExistingInvitationsEnabled ||
        currentBlockCalendarTitle !== initialBlockCalendarTitle ||
        currentStartDateStr !== initialStartDateStr ||
        currentEndDateStr !== initialEndDateStr;
    return isDirty;
}
//# sourceMappingURL=isAutomaticRepliesOptionDirty.js.map